import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Conclusion
 *
 * Conclusion을 설명하세요.
 */
export const Conclusion = types
  .model('Conclusion')
  // --------------------------------------------------------------------------
  .props({
    conclusionSid: types.identifierNumber,
    conclusionContent: types.maybeNull(types.optional(types.string, '')),

    reportSid: types.optional(types.number, 0),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model conclusion --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IConclusion }) => {
      const newProps = { ...self, ...props } as IConclusion;
      (Object.keys(newProps) as TConclusionKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TConclusion = Instance<typeof Conclusion>;
type TConclusionSnapshot = SnapshotOut<typeof Conclusion>;

export interface IConclusion extends TConclusion {}
export type TConclusionKeys = keyof TConclusionSnapshot & string;
export interface IConclusionSnapshot extends TConclusionSnapshot {}
export const createConclusion = () =>
  types.optional(Conclusion, { conclusionSid: 0 } as TConclusion);
